module.exports = require("./AceEditorVue");